module.exports = __webpack_public_path__ + "img/HQ-PA050W2T2RS-T.7fc7bdfb.jpg";